const config = {
  BASE_URL: "https://api.vsl.outsite.app",
  BASE_URL_DEV: "https://dev.api.vsl.outsite.app",
};

export default config;
